import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskTicketCommentContent } from 'src/app/interfaces/zendesk-ticket-comment-content';

import { BaseModel } from './base-model';
import { ZendeskTicket } from './zendesk-ticket';
import { ZendeskTicketAttachment } from './zendesk-ticket-attachment';

export class ZendeskTicketComment extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskTicketCommentProperties: (
    | {
        property: keyof ZendeskTicketComment;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskTicketComment;
        type: 'alias';
      }
    | {
        property: keyof ZendeskTicketComment;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ZendeskTicketCommentId', type: 'column', dataType: 'number' },
    { property: 'ZendeskTicketId', type: 'column', dataType: 'number' },
    { property: 'LocalZendeskTicketId', type: 'column', dataType: 'number' },
    { property: 'commentText', type: 'column', dataType: 'string' },
    { property: 'isInternalNote', type: 'column', dataType: 'boolean' },
    { property: 'ticketCommentContentJSON', type: 'column', dataType: 'JSON' },
    { property: 'createdAt', type: 'column', dataType: 'JSON' },
    { property: 'updatedAt', type: 'column', dataType: 'JSON' }
  ];

  static {
    ZendeskTicketComment.ZendeskTicketCommentProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ZendeskTicketComment.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          ZendeskTicketComment.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ZendeskTicketComment.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(ZendeskTicketCommentObject: Partial<ZendeskTicketComment>) {
    super();

    ZendeskTicketComment.ZendeskTicketCommentProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ZendeskTicketCommentObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  ZendeskTicketCommentId?: string;
  ZendeskTicketId?: string;
  LocalZendeskTicketId?: number;
  commentText?: string;
  isInternalNote?: boolean;
  ticketCommentContentJSON?: ZendeskTicketCommentContent;
  createdAt?: Date;
  updatedAt?: Date;

  ZendeskTicket?: ZendeskTicket;
  ZendeskTicketAttachments?: ZendeskTicketAttachment[];
}
